import useNav from "core/hooks/useNav";

import { usePartners } from "features/partners/fabric";
import { useStart } from "features/start/fabric";

import { useMutatePartner, useQuerySignup, useQuerySignupPermission } from "areas/partners/data";


const features = [
	{
		head: "For Editors",
		title: "Drive Up Engagement",
		list: ["Increase in Engagement", "No change in workflow", "Happy reporters", "Access other papers for free"]
	},
	{
		head: "For Revenue Officers",
		title: "More Reader Revenue",
		list: ["New source of direct revenue", "Restores Single-Copy sales revenue", "Increases ARPU for non-subs", "You set the price, not us!"]
	},
	{
		head: "For Business Leaders",
		title: "Grow Your Business",
		list: ["No cost to you", "No credit card fees", "Pays more than Apple or Google", "You make almost 80%!"]
	},
	{
		head: "For Marketing Teams",
		title: "Your Brand - Your Message",
		list: ["Readers stay on your site and app", "No Apple and Google News traffic loss", "New promotion opportunities", "Subly fits into your design"]
	},
	{
		head: "For Circulation Managers",
		title: "Stop Trial Pricing",
		list: ["Add per-article circulation", "One-click Day Pass sales", "Stop giving away samples", "Stop trial cancellations"]
	},
	{
		head: "For IT Teams",
		title: "Simple Integration",
		list: ["One-hour integration", "Supports popular CMS + Paywall", "Easy Copy/Paste guide", "Test deployments and transactions", "No SaaS costs"]
	}
];

const passes = [
	{ value: 1, label: "Day Pass" },
	{ value: 7, label: "Week Pass" }
];

export const usePartnerInterest = () => {
	const partner = usePartners();
	const start = useStart();
	const nav = useNav();

	const subscribe = {
		title: "Turn occasional visitors into a steady revenue source.",
		description:
			`Subly converts casual readers into paying customers, creating a new stream of reader revenue and boosting ad impressions without altering your subscription model or ad stack.

The news industry is changing. Subscription growth has slowed, and audiences consume stories in shorter, more flexible ways.

Subly helps you meet readers where they are, giving them easier ways to support your journalism and giving you new ways to grow revenue.`,
		align: "justify",
		action: "Interested? Learn more.",
		to: start.user ? "/partners/signup" : undefined,
		click: !start.user ? () => nav.go({ to: "/auth", search: { redirect_uri: "/partners/signup" } }) : undefined
	};

	return { ...partner, features, subscribe };
};

export const usePartnerSignup = () => {
	const partner = useMutatePartner();
	const query = useQuerySignup();
	const permission = useQuerySignupPermission();

	const step = {
		validate: query.data?.emailVerified,
		approved: query.data?.status === "Approved"
	};

	const current = (() => {
		if (step.approved || step.validate) return 2;
		return 1;
	})();

	const disabled = !permission.isPending && !permission.data?.partner;

	return { ...partner, current, disabled, query, features, passes, step };
};